import { all, call } from 'redux-saga/effects';

import getCollections from './getCollections';
import getUsdRate from './getUsdRate';

export function* ringSagas() {
  yield all([getCollections, getUsdRate].map(call));
}
